import { useOrder } from "@/context"

export function usePedidos() {
    const { order } = useOrder()
    
    const formatPrice = (price: number) => 
        (price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    return {
        order,
        formatPrice
    }
}